<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 商品中心->公共套餐 -->
    <div class="main">
      <div class="title borderShadow">公共套餐</div>
      <div class="main borderShadow">
        <div class="top flexStyle2" v-if="currentPageInfo.length >= 1">
          <div class="hands item c-animation" @click="getBefore">
            导出公共套餐
          </div>
        </div>
        <div class="bottom">
          <div
            class="hands goods flexStyle3 borderShadow"
            v-for="(item, index) of currentPageInfo"
            :key="index"
          >
            <div class="left">
              <div class="title oneLine">
                套餐名称: {{ item.setmealName || "暂无" }}
              </div>
              <div class="sku oneLine">
                套餐编号: {{ item.setmealCode || "暂无" }}
              </div>
              <div class="price oneLine">
                专享价格: ¥{{ item.marketPrice || "0.00" }}
              </div>
              <div class="tcGoods flexStyle2">
                <div class="title">套餐包含商品:</div>
                <div
                  class="item"
                  v-for="(item2, index2) of item.goodsList"
                  :key="index2"
                >
                  商品{{ item2.goodsName }}
                </div>
              </div>
            </div>
          </div>
          <div class="none" v-if="currentPageInfo.length <= 0">
            暂无可选择套餐
          </div>
        </div>
        <pages
          v-if="currentPageInfo.length >= 1"
          :totalPages="totalPages"
          :currentPages="currentPages"
          :totalData="totalData"
          :pagesData="pagesData"
          @uppage="uppage"
          @downpage="downpage"
          @turn="turn"
        ></pages>
      </div>
    </div>
    <!-- 商品中心->公共套餐 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import pages from "../../../components/pages/pages";
import {
  exportReequest,
  publicTCListRequest,
} from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      totalPages: 1, // 1.1.总页码,
      currentPages: 1, // 1.2.当前页码
      totalData: 1, // 1.3.总条数
      pagesData: 10, // 1.4.每页条数
      currentPageInfo: [], // 1.5.套餐列表数据
      token: "", // 1.6.token
    };
  },

  components: {
    // 2.components
    pages, // 2.1.公共pages
  },

  methods: {
    // 3.methods
    uppage() {
      // 3.1.上一页
      this.currentPages--;
      this.currentPageInfo = [];
      this.getCurrentPageInfo();
    },

    downpage() {
      // 3.2.下一页
      this.currentPages++;
      this.currentPageInfo = [];
      this.getCurrentPageInfo();
    },

    turn(tragetPage) {
      // 3.3.转跳到指定页面
      this.currentPages = tragetPage;
      this.currentPageInfo = [];
      this.getCurrentPageInfo();
    },

    getCurrentPageInfo() {
      // 3.4.获取套餐列表信息
      let data = {
        pageNum: this.currentPages,
        pageSize: this.pagesData,
      };

      publicTCListRequest(data).then((res) => {
        this.currentPageInfo = res.data;
        this.totalData = res.totals || 1;
        this.totalPages = Math.ceil(res.totals / this.pagesData) || 1;
      });
    },

    getBefore() {
      // 3.5.导出之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认导出?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.get();
          }
        },
      });
    },

    get() {
      // 3.6.导出
      exportReequest("api/export/meal").then((res) => {
        if (res) {
          var aLink = document.createElement("a");
          aLink.href = res.url;
          aLink.download = "公共套餐.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
        }
      });
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getCurrentPageInfo(); // 4.1.获取套餐列表信息
    }
  },
};
</script>

<style scoped lang="scss">
$ui-width: 1350px;
@function px2vw($px) {
  @return $px / $ui-width * 100vw;
}

$mainColor1: #e65a5a;
$mainColor2: #dd3242;
$mainColor3: #ff0000;

/* 1.all-container-style-start */
.all-container {
  border-radius: px2vw(6px);
  overflow: hidden;
  box-sizing: border-box;
  padding: px2vw(2px);
  width: 100%;

  > .main {
    flex: 1;
    border-radius: px2vw(6px);
    overflow: hidden;
    box-sizing: border-box;
    padding: px2vw(2px);

    > div {
      border-radius: px2vw(6px);
      overflow: hidden;
      margin-bottom: px2vw(20px);
      overflow: hidden;
      width: 100%;
      box-sizing: border-box;
      padding: px2vw(10px) px2vw(20px);
    }

    > .title {
      font-size: 15px;
      color: #999;
      font-weight: bold;
    }

    > .main {
      > .top {
        flex-wrap: wrap;
        margin: 10px 0;

        > .item {
          padding: 10px 20px;
          background-color: $mainColor1;
          color: #fff;
          border-radius: px2vw(4px);
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 px2vw(10px) px2vw(10px) 0;
        }
      }

      > .bottom {
        > .goods {
          margin-bottom: 20px;
          box-sizing: border-box;
          padding: 10px 10px 40px 10px;
          border-radius: px2vw(5px);
          overflow: hidden;
          font-size: 13px;
          position: relative;

          > .left {
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;

            > .title {
              font-size: 15px;
              font-weight: bold;
            }

            > .sku {
              font-size: 13px;
              color: #999;
              margin: px2vw(4px) 0;
            }

            > .price {
              color: $mainColor3;
              font-size: 13px;
              font-weight: bold;
              margin-bottom: 10px;
            }

            > .tcGoods {
              flex-wrap: wrap;
              align-items: baseline;

              > .title {
                font-size: 14px;
                margin-right: 20px;
              }

              > .item {
                margin-right: 10px;
                margin-bottom: 10px;
              }
            }
          }

          > .right {
            flex-shrink: 0;
            margin-left: 20px;
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
            position: absolute;
            bottom: px2vw(10px);
            right: px2vw(10px);

            > .btns {
              width: px2vw(80px);
              height: px2vw(30px);
              max-width: 80px;
              max-height: 30px;
              background-color: $mainColor1;
              color: #fff;
              border-radius: px2vw(4px);
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 20px;
            }
          }
        }

        > .none {
          font-size: 15px;
          color: #999;
        }
      }
    }
  }
}
/* 1.all-container-style-start */
</style>
